// MySubscription only. This page has no table, so it doesn't use tableMixin.
export default {
    name: "MySubscription",
    methods: {
        handleAlert(daOrigin, daMessage, daClass, daPageOrModal) {
            this.$displayAlert(daOrigin, daMessage, daClass, daPageOrModal);
        },
        // After a successful payment: message on the dashboard, close the window, go to the dashboard
        handleSaveOrEditSuccess(response) {
            this.handleAlert("ending", response.data.message, "success", "page");
            this.$hideModal("recordFormModal");
            sessionStorage.setItem("dashboard_message", response.data.message);
            this.$router.push("/dashboard/");
        },
    },
};